import { LatLngExpression } from "leaflet";
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import { Icon } from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import styles from "./CoordsMap.module.scss";
import "leaflet/dist/leaflet.css";
import cn from "classnames";
import { memo, useEffect, useRef, useState } from "react";
import { getLocationName } from "@utils/getCurrentLocation";
import { Modal } from "antd";
import { dev } from "@utils/dev";
import Button from "@components/global/new/Button/Button";
import { useIntl } from "react-intl";
import Title from "@components/global/new/Title/Title";
import { LoadingOutlined } from "@ant-design/icons";

export interface ICoordsMap3Props {
  readonly className?: string;
  readonly coords?: LatLngExpression;
  readonly openMapModal: boolean;

  getCoords(coords: LatLngExpression): void;
  setOpenMapModal(b: boolean): void;
}

const useControl = (props: ICoordsMap3Props) => {
  const {
    coords = [55.982737038407954, 92.91122818482344],
    getCoords,
    setOpenMapModal,
  } = props;

  const [c, setC] = useState<LatLngExpression>(coords);
  const [city, setCity] = useState<string>();

  const onSave = () => {
    getCoords(c);
    setOpenMapModal(false);
  };
  return {
    c,
    city,

    setC,
    setCity,
    onSave,
  };
};

const CoordsMap3 = (props: ICoordsMap3Props) => {
  const { formatMessage } = useIntl();
  const firstRender = useRef<boolean>(true);
  const [locationLoader, setLocationLoader] = useState<boolean>(false);
  const control = useControl(props);

  useEffect(() => {
    (async () => {
      const coords = props.coords
        ? props.coords
        : ([55.982737038407954, 92.91122818482344] as LatLngExpression);
      control.setC(coords);
      setLocationLoader(true);
      const cityData = await getLocationName(coords as number[]);
      control.setCity(cityData);
      setLocationLoader(false);
    })();
  }, []);

  const MapMarker = () => {
    const map = useMapEvents({
      async click(e) {
        control.setC([e.latlng.lat, e.latlng.lng]);
        setLocationLoader(true);
        const cityData = await getLocationName([e.latlng.lat, e.latlng.lng]);
        dev.log(cityData);
        control.setCity(cityData);
        setLocationLoader(false);
      },
    });
    useEffect(() => {
      if (firstRender.current) {
        firstRender.current = false;
        return;
      }
      map.flyTo(control.c, map.getZoom());
    }, [control.c]);

    return (
      <Marker
        icon={new Icon({ iconUrl: markerIconPng, iconAnchor: [10, 41] })}
        position={control.c}
      />
    );
  };

  return (
    <Modal
      className={styles.modal}
      width={"100%"}
      open={props.openMapModal}
      onCancel={() => props.setOpenMapModal(false)}
      onOk={() => props.setOpenMapModal(false)}
      closeIcon={false}
      closable={false}
      footer={false}
      destroyOnClose
      centered
    >
      <MapContainer
        center={control.c}
        zoom={9}
        className={cn(styles.map_wrapper, props.className)}
        scrollWheelZoom
        markerZoomAnimation
      >
        <TileLayer url='https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png' />
        <MapMarker />
      </MapContainer>
      {control.city && (
        <div className={cn(styles.location_info)}>
          <Title className={styles.coords}>
            {control.c.toString()}{" "}
            {locationLoader && (
              <LoadingOutlined className={styles.loader} rev={undefined} />
            )}
          </Title>
          <p
            className={cn(styles.text, {
              [styles.loading]: locationLoader,
            })}
          >
            {control.city}
          </p>
          <div className={styles.btns}>
            <Button className={styles.btn} onClick={control.onSave}>
              {formatMessage({ id: "modal.location.btn.save" })}
            </Button>
            <Button
              className={styles.btn}
              onClick={() => props.setOpenMapModal(false)}
              white
            >
              {formatMessage({ id: "modal.location.btn.cancel" })}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
}

export default memo(CoordsMap3);
